import cogoToast from "cogo-toast";
import { createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
  },
  reducers: {
    addToCart(state, action) {
      const product = action.payload.product || action.payload;
      const cartQuantity = action?.payload?.cartQuantity;

      const cartItem = state.cartItems.find(
        (item) =>
          item.id === product.id &&
          (product.cartItemId ? product.cartItemId === item.cartItemId : true)
      );

      const requestedQty = product.quantity_in_cart
        ? product.quantity_in_cart
        : cartQuantity || 1;
      const currentQtyInCart = cartItem ? cartItem.quantity_in_cart : 0;
      const totalAfterAdd = currentQtyInCart + requestedQty;

      // تحقق هل الكمية المطلوبة تتجاوز المتوفر
      if (totalAfterAdd > product.quantity) {
        cogoToast.warn(
          "لا يمكن إضافة المزيد، تم الوصول للحد الأقصى من الكمية المتوفرة",
          {
            position: "bottom-center",
            heading: t("cart"),
          }
        );
        return;
      }

      if (!cartItem) {
        state.cartItems.push({
          ...product,
          quantity_in_cart: requestedQty,
          cartItemId: product.id,
          price: product.price - product?.price * (product?.discount / 100),
        });
      } else {
        state.cartItems = state.cartItems.map((item) => {
          if (item.cartItemId === cartItem.cartItemId) {
            return {
              ...item,
              quantity_in_cart: totalAfterAdd,
            };
          }
          return item;
        });
      }

      cogoToast.success(t("item_added_to_cart"), {
        position: "bottom-center",
        heading: t("cart"),
      });
    },
    deleteFromCart(state, action) {
      state.cartItems = state.cartItems.filter(
        (item) => item.cartItemId !== action.payload
      );
      cogoToast.error(t("item_removed_from_cart"), {
        position: "bottom-center",
        heading: t("cart"),
      });
    },
    decreaseQuantity(state, action) {
      const product = action.payload;
      if (product.quantity_in_cart === 1) {
        state.cartItems = state.cartItems.filter(
          (item) => item.cartItemId !== product.cartItemId
        );
        cogoToast.error(t("item_removed_from_cart"), {
          position: "bottom-center",
          heading: t("cart"),
        });
      } else {
        state.cartItems = state.cartItems.map((item) =>
          item.cartItemId === product.cartItemId
            ? { ...item, quantity_in_cart: item.quantity_in_cart - 1 }
            : item
        );
        cogoToast.warn("نقص كمية المنتج", {
          position: "bottom-center",
          heading: t("cart"),
        });
      }
    },
    deleteAllFromCart(state) {
      state.cartItems = [];
    },
  },
});

export const {
  addToCart,
  deleteFromCart,
  decreaseQuantity,
  deleteAllFromCart,
} = cartSlice.actions;
export default cartSlice.reducer;
